import { BookingLocationType } from '@navio/nsdk';
import type { NoddiIconName as IconName } from 'noddi-ui-common';
import { type FilterOption } from 'noddi-ui-web';
import { BOOKING_LOCATION_TYPE_OPTIONS } from 'noddi-util';

const locationTypeIconMap: Record<BookingLocationType, IconName> = {
  [BookingLocationType.MOBILE]: 'LocationEdit',
  [BookingLocationType.STATIONARY]: 'Warehouse'
};

/** Mobile and stationary, with their icons. */
export const BOOKING_LOCATION_TYPE_FILTER_OPTIONS: FilterOption<BookingLocationType>[] =
  BOOKING_LOCATION_TYPE_OPTIONS.map((opt) => ({ ...opt, icon: locationTypeIconMap[opt.value] }));
